(function(){
  var isWishlist = /^\/pages\/wishlist(\/|$)/.test(location.pathname);

  /* ---------- styles ---------- */
  if(!document.getElementById('ps-wl-style')){
    var st=document.createElement('style'); st.id='ps-wl-style';
    st.textContent=[
      '#notepad-anchor-title,a[href="#swym-wishlist"],.swym-wishlist-modal-container,.swym-modals-container .swym-wishlist-modal-container,.swym-wishlist-notifications-container,.swym-aw-notification{display:none!important;}',
      '.ps-wl-count,a[href="/cart"] .ps-cartcount{position:absolute;min-width:16px;height:16px;padding:0 4px;border-radius:9px;background:#ab8c52!important;color:#fff!important;font-size:10px;line-height:16px;text-align:center;font-family:inherit;font-weight:600;pointer-events:none;}',
      '.ps-wl-count{top:-6px;right:-8px;}',
      '#ps-wl-bar{margin:20px auto 0;padding:0 24px;text-align:center;}',
      '.ps-wl-prompt{font-size:14px;color:#fff;margin:0 0 12px;text-shadow:0 1px 3px rgba(0,0,0,.3);}',
      '.ps-wl-prompt a{color:#fff;text-decoration:underline;text-underline-offset:3px;}',
      '.ps-wl-actions{display:flex;flex-wrap:wrap;justify-content:center;gap:22px;}',
      '.ps-wl-actions button{display:inline-flex;align-items:center;gap:7px;background:none;border:0;cursor:pointer;font-family:inherit;font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:#fff;padding:6px 4px;text-shadow:0 1px 3px rgba(0,0,0,.3);}',
      '.ps-wl-actions button:hover{color:#ab8c52;}',
      '.ps-wl-actions svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:1.5;}',
      '.ps-atb{display:block;width:100%;margin-top:12px;padding:13px 16px;background:transparent;border:1px solid #212121;color:#212121;font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;border-radius:2px;transition:background .15s ease,opacity .15s ease;}',
      '.ps-atb:hover{background:rgba(33,33,33,.04);}',
      '.ps-atb[disabled]{opacity:.55;cursor:default;}',
      '.ps-toast{position:fixed;left:50%;bottom:34px;transform:translateX(-50%);background:#212121;color:#fbfaf6;font-family:inherit;font-size:13px;letter-spacing:.04em;padding:12px 20px;border-radius:3px;z-index:100000;transition:opacity .4s ease;box-shadow:0 6px 20px rgba(0,0,0,.18);}',
      /* wishlist-page remove (X) badge — always visible, both breakpoints */
      '.ps-wl-remove{position:absolute;top:8px;right:8px;z-index:4;width:30px;height:30px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:999px;background:rgba(251,250,246,.92);box-shadow:0 1px 4px rgba(0,0,0,.12);cursor:pointer;transition:background .15s ease,transform .15s ease,opacity .2s ease;}',
      '.ps-wl-remove svg{width:14px;height:14px;stroke:#232220;stroke-width:1.6;fill:none;stroke-linecap:round;}',
      '.ps-wl-remove:hover{background:#fff;transform:scale(1.05);}',
      '.ps-wl-remove:hover svg{stroke:#ab8c52;}',
      '.ps-wl-remove.is-removing{opacity:.4;pointer-events:none;}',
      '@media (max-width:767px){.ps-wl-remove{top:6px;right:6px;width:28px;height:28px;} .ps-wl-remove svg{width:13px;height:13px;}}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ---------- helpers ---------- */
  function loggedIn(){ return window.PS_LOGGED_IN===true; }
  function swymReady(cb){
    window.SwymCallbacks=window.SwymCallbacks||[];
    window.SwymCallbacks.push(function(){ try{cb();}catch(e){} });
    if(window._swat && window._swat.fetch){ try{cb();}catch(e){} }
  }
  function getCount(cb){ try{ window._swat.fetch(function(items){ cb(Array.isArray(items)?items.length:0); }, function(){ cb(null); }); }catch(e){ cb(null); } }
  function toast(msg){ var t=document.createElement('div'); t.className='ps-toast'; t.textContent=msg; document.body.appendChild(t); setTimeout(function(){t.style.opacity='0';},1900); setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); },2400); }

  /* ---------- nav wishlist count badge (all pages) ---------- */
  function renderBadge(n){
    var links=[].slice.call(document.querySelectorAll('a[href="/pages/wishlist"]')).filter(function(a){ return !a.classList.contains('foot-row') && !a.closest('footer'); });
    links.forEach(function(a){
      var b=a.querySelector('.ps-wl-count');
      if(n>0){
        if(!b){ b=document.createElement('span'); b.className='ps-wl-count'; if(getComputedStyle(a).position==='static') a.style.position='relative'; a.appendChild(b); }
        b.textContent=n;
      } else if(b){ b.parentNode.removeChild(b); }
    });
  }
  function refreshBadge(){ getCount(function(n){ if(n!=null) renderBadge(n); }); }
  swymReady(refreshBadge);
  ['swym:wishlist-added','swym:wishlist-removed','swym:collections-updated','swym:collections-loaded'].forEach(function(ev){ document.addEventListener(ev, refreshBadge); });
  document.addEventListener('click', function(e){ var t=e.target.closest?e.target.closest('[aria-label*="Wishlist" i],#ps-wishlist-link,[class*="wishlist" i]'):null; if(t){ setTimeout(refreshBadge,700); setTimeout(refreshBadge,1600); } }, true);

  /* ---------- wishlist page enhancements ---------- */
  if(isWishlist){
    function variantOf(card){
      try{ var s=card._x_dataStack&&card._x_dataStack[0];
        if(s){ if(s.currentVariant&&s.currentVariant.id) return s.currentVariant.id;
                if(s.possibleVariants&&s.possibleVariants.length){ var av=s.possibleVariants.filter(function(v){return v&&v.available;}); return (av[0]||s.possibleVariants[0]).id; } }
      }catch(e){}
      return null;
    }
    function addToCart(items, then){
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.ok?r.json():Promise.reject(); }).then(function(){ then(true); }).catch(function(){ then(false); });
    }
    /* the theme's own wishlist toggle button inside a card (Alpine-powered) */
    function nativeWishBtn(card){
      return card.querySelector('button[x-data^="wishlist"]') || card.querySelector('button[aria-label*="Wishlist" i]');
    }
    function buildBar(){
      if(document.getElementById('ps-wl-bar')) return;
      var h1=document.querySelector('h1.hero__title');
      if(!h1) return;
      var wrap=document.createElement('div'); wrap.id='ps-wl-bar';
      var prompt = loggedIn()? '' : '<p class="ps-wl-prompt">To save your wishlist please <a href="/account/login">log in</a> or <a href="/account/register">sign up</a>.</p>';
      wrap.innerHTML = prompt +
        '<div class="ps-wl-actions">'+
        '<button type="button" id="ps-wl-share"><svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 10.5 15.4 6.5M8.6 13.5 15.4 17.5"/></svg>Share wishlist</button>'+
        '<button type="button" id="ps-wl-addall"><svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M6 6 5 3H2"/></svg>Add wishlist to cart</button>'+
        '</div>';
      h1.parentNode.insertBefore(wrap, h1.nextSibling);
      document.getElementById('ps-wl-share').addEventListener('click', function(){
        var done=false;
        function ok(u){ if(done) return; done=true; if(u && navigator.clipboard){ navigator.clipboard.writeText(u).then(function(){toast('Wishlist link copied');},function(){ window.prompt('Copy your wishlist link:', u); }); } else if(u){ window.prompt('Copy your wishlist link:', u); } else { fail(); } }
        function fail(){ if(done) return; done=true; toast(loggedIn()? 'Sorry, could not create a link — please retry' : 'Please log in to share your wishlist'); }
        try{ window._swat.generateSharedWishlistURL(ok, fail); }catch(e){ fail(); }
        setTimeout(fail, 4000);
      });
      document.getElementById('ps-wl-addall').addEventListener('click', function(){
        var cards=[].slice.call(document.querySelectorAll('main .product-item'));
        var items=cards.map(variantOf).filter(Boolean).map(function(id){return {id:id,quantity:1};});
        if(!items.length){ toast('Your wishlist is empty'); return; }
        addToCart(items, function(ok){ if(ok) location.href='/cart'; else toast('Sorry, something went wrong'); });
      });
    }
    function addButtons(){
      [].slice.call(document.querySelectorAll('main .product-item')).forEach(function(card){
        if(card.querySelector('.ps-atb')) return;
        var btn=document.createElement('button'); btn.type='button'; btn.className='ps-atb'; btn.textContent='Add to Bag';
        card.appendChild(btn);
        btn.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation();
          var id=variantOf(card); if(!id){ location.href = (card.querySelector('a[href*="/products/"]')||{}).href || '#'; return; }
          btn.disabled=true; btn.textContent='Adding…';
          addToCart([{id:id,quantity:1}], function(ok){ if(ok){ location.href='/cart'; } else { btn.disabled=false; btn.textContent='Add to Bag'; toast('Sorry, could not add'); } });
        });
      });
    }
    /* Always-visible X to remove a card from the wishlist (desktop + mobile).
       The theme only shows its heart on hover (desktop) and hides it entirely on mobile,
       so we add our own X and hide the native heart on this page to avoid duplication.
       Removal reuses the theme's own toggle (programmatic click), which fires
       removeFromWishList() and dispatches wishlist-updated to re-render the grid. */
    function addRemove(){
      [].slice.call(document.querySelectorAll('main .product-item')).forEach(function(card){
        var nb=nativeWishBtn(card);
        if(nb){ var wrap=nb.closest('.absolute')||nb.parentNode; if(wrap && wrap.getAttribute('data-ps-hidden')!=='1'){ wrap.style.display='none'; wrap.setAttribute('data-ps-hidden','1'); } }
        if(card.querySelector('.ps-wl-remove')) return;
        var host=card.querySelector('.product-item__image')||card;
        if(getComputedStyle(host).position==='static'){ host.style.position='relative'; }
        var x=document.createElement('button');
        x.type='button'; x.className='ps-wl-remove'; x.setAttribute('aria-label','Remove from wishlist');
        x.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg>';
        host.appendChild(x);
        x.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation();
          var btn=nativeWishBtn(card);
          if(btn){ x.classList.add('is-removing'); btn.click(); }
          else { card.style.transition='opacity .3s ease'; card.style.opacity='0'; setTimeout(function(){ if(card.parentNode) card.parentNode.removeChild(card); },320); }
        });
      });
    }
    var pending=false;
    function process(){ if(pending) return; pending=true; requestAnimationFrame(function(){ pending=false; buildBar(); addButtons(); addRemove(); }); }
    var tries=0, iv=setInterval(function(){ process(); if(document.querySelector('.ps-atb') || ++tries>25){ clearInterval(iv); } },400);
    try{ new MutationObserver(process).observe(document.querySelector('main')||document.body,{childList:true,subtree:true}); }catch(e){}
    process();
  }
})();
